import styled from "styled-components/macro";

export const Fields = styled.div`
  display: grid;
  grid-template-columns: repeat(${({ $numColumns }) => $numColumns}, 1fr);
  gap: 1rem;
  margin: 1rem 0;
`;
